angular.module('env.customConfig.templates', [
    'env.customConfig.provider',
    'env.customConfig.logicResolvers',
    "env.custom.customModule"
])
    .config(function ($customisationConfigProvider, $customLogicResolversProvider) {
        $customisationConfigProvider.templates =
            [
                {
                    name: "signup-link-template",
                    resolve: function (context) {
                        return "";
                        //return "customise/html/" + this.name + "/" + this.name + ".html";
                    }
                },
                {
                    name: "login-screen-band",
                    resolve: function (context) {
                        //context object for login-screen-band will be of the form: { user: %currentUserObject% }

                        //For some company branded site when we do need lower band on login screen
                        //The path isn't calculated as this needs serving directly before the customisation system has fully started
                        return "customise/html/" + this.name + "/" + this.name + ".html";

                        // For some other cases we don't need lower band on login screen
                        //return "";
                    }
                },
                {
                    name: "home-view-custom-content",
                    resolve: function (context) {
                        //context object for home-view-custom-content will be of the form: { user: %currentUserObject% }

                        //Calculated prefix of the customised resource name from context information (current user, step, etc.)
                        //will be used to find the corresponding resource's URI in the resources map that are available on the server
                        return $customLogicResolversProvider.resolveResourceUri(context, this.name + ".html");
                    }
                },
                {
                    name: "order-attachment-header",
                    resolve: function(context) {
                        //context object for order-attachment-header will be of the form: { user: %currentUserObject% }

                        //Calculated prefix of the customised resource name from context information (current user, step, etc.)
                        //will be used to find the corresponding resource's URI in the resources map that are available on the server
                        return $customLogicResolversProvider.resolveResourceUri(context, this.name + ".html");
                    }
                },
                {
                    name: "additional-fields",
                    resolve: function (context) {
                        //context object for additional-fields will be of the form: { user: %currentUserObject%, step: %stepCode% }

                        //Calculated prefix of the customised resource name from context information (current user, step, etc.)
                        //will be used to find the corresponding resource's URI in the resources map that are available on the server
                        return $customLogicResolversProvider.resolveResourceUri(context, this.name + ".html");
                    }
                },
                {
                    name: "step-details-pager-item-template",
                    resolve: function (context) {
                        //context object for step-details-pager-item-template will be of the form: { user: %currentUserObject%, step: %stepCode% }

                        //Calculated prefix of the customised resource name from context information (current user, step, etc.)
                        //will be used to find the corresponding resource's URI in the resources map that are available on the server
                        return $customLogicResolversProvider.resolveResourceUri(context, this.name + ".html");
                    }
                },
                {
                    name: "step-details-pager-item-loading-template",
                    resolve: function (context) {
                        //context object for step-details-pager-item-loading-template will be of the form: { user: %currentUserObject%, step: %stepCode% }

                        //Calculated prefix of the customised resource name from context information (current user, step, etc.)
                        //will be used to find the corresponding resource's URI in the resources map that are available on the server
                        return $customLogicResolversProvider.resolveResourceUri(context, this.name + ".html");
                    }
                },
                {
                    name: "order-item-summary-template",
                    resolve: function (context) {
                        //context object for order-item-summary-template will be of the form: { user: %currentUserObject%, step: %stepCode% }

                        //Calculated prefix of the customised resource name from context information (current user, step, etc.)
                        //will be used to find the corresponding resource's URI in the resources map that are available on the server
                        return $customLogicResolversProvider.resolveResourceUri(context, this.name + ".html");
                    }
                },
                {
                    name: "sample-template",
                    resolve: function (context) {
                        return "customise/html/sample-template/_general_sample-template.html";
                    }
                },
                {},
                {}
            ];
    })
;
